/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Building_Holidays_Settings_HelpInputs */



/**
* | output |
* | --- |
* | "In summer mode, a holiday period stops production In winter mode, a holiday period starts frost-free mode" |
*
* @param {Building_Holidays_Settings_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const building_holidays_settings_help = /** @type {((inputs?: Building_Holidays_Settings_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Building_Holidays_Settings_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("In summer mode, a holiday period stops production\nIn winter mode, a holiday period starts frost-free mode")
	return /** @type {LocalizedString} */ ("En mode été, une période de vacances arrête la production\nEn mode hiver, une période de vacances démarre le Hors Gel")
});